const baseURL = process.env.REACT_APP_CONVOZE_BASE_API_URL;

// const apiEndPointsConfig = {
//   addLogin: `${baseURL}/user-login`,
//   register: `${baseURL}/add-user`,
//   upload: `${baseURL}/call-recording/upload`,
//   demoUploadFile: `${baseURL}/call-recording/demo-upload`,
//   audioTable: `${baseURL}/call-recording/get-all`,
//   transcript: `${baseURL}/transcript/call-recording`,
//   dashboard: `${baseURL}/dashboard/insights`,
//   industryType: `${baseURL}/industry-type-list`,
//   demoTranscript: `${baseURL}/audio-insight`,
//   interaction: `${baseURL}/interactions`,
//   interactionList: `${baseURL}/interactions`,
//   qaParameters: `${baseURL}/qa-audit`,
//   agentCampaignList: `${baseURL}/filter-details`,
//   userProfile: `${baseURL}/user-details `,
//   //agent
//   agentMyCalls: `${baseURL}/agent/call-analytics`,
//   agentDashboard: `${baseURL}/agent/dashboard`,
//   agentLeaderboard: `${baseURL}/agent/leaderboard`,
// };

const apiEndPointsConfig = {
  addLogin: `${baseURL}/manager-panel/login`,
  register: `${baseURL}/manager-panel/add-user`,
  upload: `${baseURL}/manager-panel/call-recording/upload`,
  publicUpload: `${baseURL}/manager-panel/call-recording/public-upload`,
  demoUploadFile: `${baseURL}/manager-panel/call-recording/demo-upload`,
  audioTable: `${baseURL}/manager-panel/call-recording/list`,
  transcript: `${baseURL}/manager-panel/transcription/audio-insight`,
  dashboard: `${baseURL}/manager-panel/dashboard/insights`,
  interactionTrendAnalytics: `${baseURL}/manager-panel/interactions/last-month-trends`,
  industryType: `${baseURL}/manager-panel/industry-type/list`,
  demoTranscript: `${baseURL}/audio-insight`,
  interaction: `${baseURL}/manager-panel/interactions/list`,
  interactionList: `${baseURL}/manager-panel/interactions`,
  qaParameters: `${baseURL}/manager-panel/qa-audit`,
  agentCampaignList: `${baseURL}/manager-panel/interactions/filter-details`,
  userProfile: `${baseURL}/manager-panel/profile-details`,
  agentList: `${baseURL}/manager-panel/agent-list`,
  changePassword: `${baseURL}/manager-panel/change-password`,
  billing: `${baseURL}/manager-panel/billing-invoice`,
  agentProfile: `${baseURL}/manager-panel/agent-profile `,
  exportExcelInteraction: `${baseURL}/manager-panel/interactions/excel-interaction`,
  chatbotApi: `${baseURL}/chatbot/chatbot-query`,
  companyList: `${baseURL}/super-admin-panel/companies`,
  ReprocessQaparameter: `${baseURL}/manager-panel/reprocess-qa-audit`,
  ReprocessInteractionInsight: `${baseURL}'/manager-panel/reprocess-interaction'`,
  reTranscribe: `${baseURL}/manager-panel/transcription/re-transcribe`,
  reTranscribeStatus: `${baseURL}/manager-panel/transcription/re-transcribe/status`,
  updateQaParameters: `${baseURL}/manager-panel/update-qa-parameters`,
  updateMultipleQaParameters: `${baseURL}/manager-panel/update-multiple-qa-parameters`,
  toggleCuration: `${baseURL}/manager-panel/interactions/toggle-curation`,



  // super admin 
  defaultListOfQAparameter: `${baseURL}/convoze-default-prompt`,
  invoiceGeneration: `${baseURL}/super-admin/billing-invoice`,
  downloadInvoice: `${baseURL}/super-admin/download-invoice`,
  clientOnboarding: `${baseURL}/super-admin-panel/client-management`,
  clientList: `${baseURL}/super-admin-panel/client-list`,
  updateCompanyData: `${baseURL}/super-admin-panel/update-client-data`,
  clinetPromptData: `${baseURL}/super-admin-panel/client-prompt-data`,
  updateClientPrompt: `${baseURL}/super-admin-panel/update-client-prompt`,
  processList: `${baseURL}/super-admin-panel/process-list`,
  processPromptData: `${baseURL}/super-admin-panel/process-prompt-data`,



  //agent
  agentMyCalls: `${baseURL}/agent-panel/call-analytics`,
  agentDashboard: `${baseURL}/agent-panel/dashboard/insights`,
  agentLeaderboard: `${baseURL}/agent-panel/leaderboard`,
  agentKpis: `${baseURL}/agent-panel/kpis-analytics`,


  //user management 
  createUser: `${baseURL}/manager-panel/users-add`,
  updateUser: `${baseURL}/manager-panel/update-user`,
  getUsers: `${baseURL}/manager-panel/user-management`,
  deleteUser: `${baseURL}/manager-panel/delete-user`,
  uploadSop: `${baseURL}/sop-training/upload`,
  hrList: `${baseURL}/manager-panel/hr-list`,
  candidateDetail: `${baseURL}/manager-panel/candidate-detail`
};

export default apiEndPointsConfig;
